import script from "./MyBookmarkedServicesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./MyBookmarkedServicesTab.vue?vue&type=script&setup=true&lang=js"

import "./MyBookmarkedServicesTab.vue?vue&type=style&index=0&id=a441b966&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a441b966"]])

export default __exports__